import { render, staticRenderFns } from "./task_sample.vue?vue&type=template&id=79be4c7c&scoped=true"
import script from "./task_sample.vue?vue&type=script&lang=js"
export * from "./task_sample.vue?vue&type=script&lang=js"
import style0 from "./task_sample.vue?vue&type=style&index=0&id=79be4c7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79be4c7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79be4c7c')) {
      api.createRecord('79be4c7c', component.options)
    } else {
      api.reload('79be4c7c', component.options)
    }
    module.hot.accept("./task_sample.vue?vue&type=template&id=79be4c7c&scoped=true", function () {
      api.rerender('79be4c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/task_sample.vue"
export default component.exports